export const LOGOUT_URL = `${process.env.REACT_APP_WEBAPP_HOST}/logout/`;
export const BASE_URL = '/auth/login';
